import { render, staticRenderFns } from "./EscrivaoInput.vue?vue&type=template&id=497280a3&"
import script from "./EscrivaoInput.vue?vue&type=script&lang=js&"
export * from "./EscrivaoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports